import { ROUTES } from '#client/manifest';

const PRODUCTS_WITH_FORMATION_INFO = [
  'change_of_registered_agent',
  'registered_agent_service',
  'dba_entity',
  'ein_creation',
  'worry_free_service'
];

const PRODUCTS_SUGGESTING_FORMATION = [
  ...PRODUCTS_WITH_FORMATION_INFO,
  'ny_publication'
];

export const NON_ENTITY_URLS = [
  ROUTES.accountSettings,
  ROUTES.help,
  ROUTES.payments,
  ROUTES.financialReadiness
];

/**
 * HACK To help us determine if a entity is likely formed
 * FIXME Please
 *
 * @param {object} entitlements
 * @returns {boolean}
 */
export const isSuggestingFormation = (entitlements) => {
  const hasProductSuggestingFormation = PRODUCTS_SUGGESTING_FORMATION.find(entitlements.has);
  return !!hasProductSuggestingFormation;
};

/**
 * HACK To help us determine if a entity is likely formed
 * FIXME Please
 *
 * @param {object} businessEntity
 * @param {string} businessEntity.businessEntityType
 * @param {object} entitlements
 * @returns {boolean}
 */
export const isLikelyFormed = ({ businessEntityType }, entitlements) => (
  entitlements.has(`${businessEntityType}_formation`) || isSuggestingFormation(entitlements)
);

/**
 * HACK To help us determine reserved entities
 * FIXME Please
 *
 * @param {object} businessEntity
 * @param {object} entitlements
 * @returns {boolean}
 */
export const isReserved = (businessEntity, entitlements) => (
  entitlements.has('entity_name_reservation') && !isLikelyFormed(businessEntity, entitlements)
);

/*
 * HACK this is to indicate all those products that suggest
 * formation but are missing information to sell some products
 */
export const hasFormationData = (entitlements) => (
  !!PRODUCTS_WITH_FORMATION_INFO.find(entitlements.has)
);

/**
 * isNewBusinessEntity
 *
 * @param {object} businessEntity
 * @param {string} currentYear
 * @returns {boolean}
 */
export const isNewBusinessEntity = (businessEntity, currentYear = new Date().getFullYear()) => {
  const filingDate = businessEntity?.jurisdictions?.[0]?.jurisdictionFilingDate || undefined;

  if (!filingDate || filingDate === undefined) return true;

  const filingDateYear = Number(filingDate.split('-')[0]);

  const arCutoffDate = (new Date(`${currentYear}-10-01 00:00:00`)).getTime();
  const today = Date.now();

  return (filingDateYear === Number(currentYear)) && (today < arCutoffDate);
};

/**
 * A temporary stop gap to filter upcoming annual reports
 *
 * @param {object} businessEntity
 * @param {number} cutoffDayCount - How many days before the due date that a report can be ordered
 * @param {Date} endDate - The cut off date for the order task date.
 * Defaults to the current date. Primarily for testing.
 * @returns {boolean}
 */
export const isAnnualReportPurchaseEnabled = (
  businessEntity,
  cutoffDayCount = 90,
  endDate = new Date()
) => {
  const incompleteEvents = businessEntity?.annualReportIncompleteCompEvts;
  const reports = incompleteEvents?.complianceReports;
  if (reports) {
    const cutoff = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    cutoff.setDate(cutoff.getDate() + cutoffDayCount);
    return reports.reduce((out, { dueDate }) => out || (new Date(dueDate) < cutoff), false);
  }

  return false;
};

/**
 * is Formation Complete
 *
 * @param {Array<object>} formationTimelineV2events Array of events provided by formationTimelineV2
 * @returns {boolean}
 */
export const isFormationComplete = (formationTimelineV2events) => formationTimelineV2events?.reduce((boolean, { step, status }) => (step === 'business_formed' && status === 'complete') || boolean, false);

/**
 * Temporary function convert new business entity structure into
 * legacy structure to prevent massive prop changes
 *
 * @param {{
 *  businessEntity?: object
 * }} queryData
 * @returns {object}
 */
export const mapBusinessEntityQuery = (queryData) => {
  // Props to be renamed
  const beDict = {
    name: 'businessEntityName',
    uuid: 'businessEntityUuid',
    type: 'businessEntityType',
    createdAt: 'createdDatetime'
  };

  const { businessEntity } = queryData;
  if (businessEntity) {
    Object.entries(beDict).forEach(([key, value]) => {
      // If prop exist, add it
      if (businessEntity[key]) {
        businessEntity[value] = businessEntity[key];
      }
    });
    return {
      ...queryData,
      businessEntity
    };
  }

  return queryData;
};
